import { render, staticRenderFns } from "./NewsPosts.vue?vue&type=template&id=1780cdc2&"
import script from "./NewsPosts.vue?vue&type=script&lang=js&"
export * from "./NewsPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports